// src/utils/api.js
import axios from "axios";

const getBaseURL = () => {
  const { hostname, protocol } = window.location;

  if (protocol === "https:") {
    return `https://${hostname}/`;
  }

  return `http://${hostname}:3000/`;
};

export const baseURL = getBaseURL();

export const api = axios.create({
  baseURL: baseURL + "api/v/",
});

// Interceptor dodający token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Helper: konwersja Date na lokalny YYYY-MM-DD (bez przesunięcia UTC)
export const toLocalDateString = (d) => {
  if (!d) return null;
  const dt = d instanceof Date ? d : new Date(d);
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// Interceptor zamieniający obiekty Date na lokalne YYYY-MM-DD w body requestów
const convertDatesInPayload = (obj) => {
  if (obj instanceof Date) return toLocalDateString(obj);
  if (Array.isArray(obj)) return obj.map(convertDatesInPayload);
  if (obj && typeof obj === "object" && !(obj instanceof FormData)) {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      out[k] = convertDatesInPayload(v);
    }
    return out;
  }
  return obj;
};

api.interceptors.request.use((config) => {
  if (config.data && !(config.data instanceof FormData)) {
    config.data = convertDatesInPayload(config.data);
  }
  return config;
});

// Interceptor obsługujący wygaśnięcie sesji (401/403) — dla instancji api
const handleAuthError = (error) => {
  if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
};

api.interceptors.response.use((response) => response, handleAuthError);

// Globalny interceptor dla axios (używanego bezpośrednio w komponentach)
axios.interceptors.response.use((response) => response, handleAuthError);

// Formatowanie daty
export const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("pl-PL");
};

// Formatowanie kwoty
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "-";
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
  }).format(amount);
};

// Tekst pozostałych dni
export const daysLeftText = (days) => {
  if (days === null || days === undefined) return "-";
  if (days <= 0) return "PRZETERMINOWANY";
  if (days === 1) return "1 dzień";
  if (days < 5) return `${days} dni`;
  return `${days} dni`;
};

// Kolor statusu terminu
export const getDeadlineColor = (status) => {
  switch (status) {
    case "overdue":
      return "#e74c3c";
    case "warning":
      return "#f39c12";
    case "ok":
      return "#27ae60";
    default:
      return "#666";
  }
};

// Etykieta statusu
export const getDeadlineLabel = (status) => {
  switch (status) {
    case "overdue":
      return "Przeterminowany";
    case "warning":
      return "Zbliża się termin";
    case "ok":
      return "OK";
    default:
      return "-";
  }
};
